import { render } from "./ResetPassword.vue?vue&type=template&id=85928db8&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=85928db8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85928db8"]])

export default __exports__